export const i18nOptions = { scope: 'proposal_content.guest_portal.guest_form' };
